import DateFnsUtils from "@date-io/date-fns";
import CssBaseline from "@material-ui/core/CssBaseline";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import PropTypes from "prop-types";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Route, Switch, useHistory } from "react-router-dom";
import Loader from "../../Components/Loader/";
import PrivateRoute from "../../Components/PrivateRoute";
import actions from "../../Stores/Auth/actions";
import Alerts from "../Alerts/";
import Login from "../Login";
import RolesAndItemsTabs from "./RolesAndItemsTabs";

const { check } = actions;

const DashBoard = lazy(() => import("./../DashBoard/"));
const Items = lazy(() => import("./../Items/"));
const Roles = lazy(() => import("./../Roles/"));
const Users = lazy(() => import("./../Users/"));
const CareHomeGroups = lazy(() => import("../CareHomeGroups"));
const CareHomeGroupsAdd = lazy(
  () => import("../CareHomeGroups/CareHomeGroupsAdd"),
);
const CareHomeGroupsView = lazy(
  () => import("../CareHomeGroups/CareHomeGroupsView"),
);
const CareHomeGroupTabs = lazy(
  () => import("../CareHomeGroups/CareHomeGroupTabs"),
);

const Homes = lazy(() => import("../Homes"));
const HomesAdd = lazy(() => import("../Homes/HomesAdd"));
const Enquiries = lazy(() => import("../Enquiries"));
const EnquiriesAdd = lazy(() => import("../Enquiries/EnquiriesAdd"));
const CareHearthAdmin = lazy(() => import("../Enquiries/CareHearth"));
const CareHearthDetail = lazy(() => import("../Enquiries/CareHearth/Detail"));
const CareHearthBuyers = lazy(() => import("../Enquiries/CareHearth/Buyers"));
const CareHearthBuyerDetail = lazy(
  () => import("../Enquiries/CareHearth/Buyers/Detail"),
);
const CareHearthInvoices = lazy(
  () => import("../Enquiries/CareHearth/Invoices"),
);
const CareHearthDisputes = lazy(
  () => import("../Enquiries/CareHearth/Disputes"),
);
const CareHearthInsights = lazy(
  () => import("../Enquiries/CareHearth/Insights"),
);
const CareHearthInsightDetail = lazy(
  () => import("../Enquiries/CareHearth/Insights/Detail"),
);

const Residence = lazy(() => import("../Residence"));
const ResidenceAdd = lazy(() => import("../Residence/ResidenceAdd"));

const News = lazy(() => import("../News"));
const NewsAdd = lazy(() => import("../News/NewsAdd"));

const Blogs = lazy(() => import("../Blogs"));
const BlogsAdd = lazy(() => import("../Blogs/BlogsAdd"));

const Reviews = lazy(() => import("../Reviews"));
const ReviewsAdd = lazy(() => import("../Reviews/ReviewsAdd"));

const TOC = lazy(() => import("../TypesOfCare"));
const TOCAdd = lazy(() => import("../TypesOfCare/TypesOfCareAdd"));

const Package = lazy(() => import("../Package"));
const PackageAdd = lazy(() => import("../Package/PackageAdd"));

const Bundles = lazy(() => import("../Bundles"));
const BundleAdd = lazy(() => import("../Bundles/BundleAdd"));

const SlickCareProfiles = lazy(() => import("../SlickCareProfiles"));
const LocationTabs = lazy(() => import("../SlickCareProfiles/LocationTabs"));
const SlickCareProfilesAdd = lazy(
  () => import("../SlickCareProfiles/SlickCareProfilesAdd"),
);
// Auth
const NotFoundPage = lazy(() => import("../NotFound/"));
const UserProfile = lazy(() => import("./../UserProfile/"));
const ChangePassword = lazy(() => import("./../ChangePassword/"));
const ResetPassword = lazy(() => import("../ResetPassword/"));
const ForgotPassword = lazy(() => import("../ForgotPassword/"));
const NoPermission = lazy(() => import("../NoPermission"));

// Email
const EmailListing = lazy(() => import("../Email"));
const ViewEmail = lazy(() => import("../Email/ViewEmail"));
const EditEmail = lazy(() => import("../Email/EditEmail"));
const AddEmail = lazy(() => import("../Email/AddEmail"));

const Notification = lazy(() => import("../Notification"));
const AddNotification = lazy(() => import("../Notification/AddNotification"));

const UploadCard = lazy(() => import("../UploadCard"));
const UploadCardAdd = lazy(() => import("../UploadCard/UploadCardAdd"));

function RootApp({ isAuthenticating, isAuthenticated, checkAuth }) {
  const history = useHistory();
  const [authFallback, setAuthFallback] = useState(true);
  const [request, setRequest] = useState(false);
  const permissions = useSelector(
    (state) => state.AuthReducer?.user?.role?.access_permissions,
  );

  const permits = useSelector((state) => state.AuthReducer?.permissions);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const getKeyAccessLink =
      history.location.pathname.startsWith("/getkeyaccess");
    const verifyAccountLink =
      history.location.pathname.startsWith("/verify/sign-up/");
    const ResetPassword =
      history.location.pathname.startsWith("/password/reset/");

    if (token) {
      checkAuth(token, history);
      setRequest(true);
    } else {
      setAuthFallback(false);

      if (getKeyAccessLink || verifyAccountLink || ResetPassword) {
      } else {
        history.replace("/");
      }
    }
  }, []);

  function findKey(value) {
    for (let key in permits) if (permits[key] === value) return key;

    return "key is not found";
  }
  function kindcheckkeys(Item_name, desired_permissions) {
    let currentItem = permissions?.filter((x) => x.item_name === Item_name);
    let permission_item = findKey(
      (currentItem?.length >= 0 && currentItem != undefined) ||
        currentItem != null
        ? currentItem[0]?.permission
        : "",
    );

    if (desired_permissions >= permission_item) {
      return true;
    }

    return false;
  }

  useEffect(() => {
    if (isAuthenticated && !isAuthenticating) {
      setAuthFallback(false);
      setTimeout(() => {
        setRequest(false);
      }, 1000);
    }
  }, [isAuthenticated, isAuthenticating]);

  return (
    <>
      <Alerts />
      <Suspense fallback={<Loader open />}>
        {isAuthenticating || authFallback || request ? (
          <>
            <Loader open />
          </>
        ) : (
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <CssBaseline />
            <Switch>
              <Route path="/" exact component={Login} />

              <Route path="/login" component={Login} />
              {/* <Route path="/postcode" render={() => <PostCode />} /> */}
              <Route
                path="/password/reset/:token/:email"
                component={ResetPassword}
              />
              <Route path="/forgot/password" component={ForgotPassword} />
              <PrivateRoute path="/d">
                <DashBoard>
                  <Suspense fallback={<Loader open />}>
                    <Switch>
                      <Route
                        exact
                        path="/d/no-permission"
                        component={NoPermission}
                      />
                      <Route path="/d/roles">
                        <RolesAndItemsTabs>
                          <Switch>
                            {kindcheckkeys("ROLE", "DISPLAY") === true && (
                              <Route exact path="/d/roles" component={Roles} />
                            )}
                            {kindcheckkeys("ITEM", "DISPLAY") === true && (
                              <Route path="/d/roles/items" component={Items} />
                            )}
                          </Switch>
                        </RolesAndItemsTabs>
                      </Route>

                      <Route path="/d/users/:id" component={Users} />
                      {kindcheckkeys("USER", "DISPLAY") === true && (
                        <Route exact path="/d/users" component={Users} />
                      )}
                      <Route
                        exact
                        path="/d/myprofile"
                        component={UserProfile}
                      />
                      <Route
                        exact
                        path="/d/change-password"
                        component={ChangePassword}
                      />
                      <Route path="/d/company">
                        <Switch>
                          <Route
                            exact
                            path="/d/company"
                            component={CareHomeGroups}
                          />
                          <Route
                            path="/d/company/add"
                            component={CareHomeGroupsAdd}
                          />
                          <Route
                            path="/d/company/edit/:id"
                            render={() => (
                              <CareHomeGroupTabs isEditing={true} />
                            )}
                          />
                          <Route
                            path="/d/company/:id"
                            render={() => (
                              <CareHomeGroupTabs isViewing={true} />
                            )}
                          />
                        </Switch>
                      </Route>
                      <Route path="/d/:companyID/location">
                        <Switch>
                          <Route
                            exact
                            path="/d/location"
                            component={SlickCareProfiles}
                          />
                          <Route
                            exact
                            path="/d/:companyID/location/add"
                            component={SlickCareProfilesAdd}
                          />
                          <Route
                            exact
                            path="/d/:companyID/location/edit/:id"
                            render={() => <LocationTabs isEditing={true} />}
                          />
                          <Route
                            exact
                            path="/d/:companyID/location/edit/:id/rooms"
                            render={() => <LocationTabs isEditing={true} />}
                          />
                          <Route
                            exact
                            path="/d/:companyID/location/edit/:id/events"
                            render={() => <LocationTabs isEditing={true} />}
                          />
                          <Route
                            exact
                            path="/d/:companyID/location/edit/:id/faqs"
                            render={() => <LocationTabs isEditing={true} />}
                          />
                          <Route
                            exact
                            path="/d/:companyID/location/edit/:id/faqs/add"
                            render={() => <LocationTabs isEditing={true} />}
                          />
                          <Route
                            exact
                            path="/d/:companyID/location/edit/:id/faqs/edit/:faqID"
                            render={() => <LocationTabs isEditing={true} />}
                          />
                          <Route
                            exact
                            path="/d/:companyID/location/edit/:id/email-settings"
                            render={() => <LocationTabs isEditing={true} />}
                          />
                          <Route
                            exact
                            path="/d/:companyID/location/edit/:id/rooms/:roomId"
                            render={() => <LocationTabs isEditing={true} />}
                          />
                          <Route
                            exact
                            path="/d/location/edit/:id/website"
                            render={() => <LocationTabs isEditing={true} />}
                          />
                          <Route
                            exact
                            path="/d/location/edit/:id/website/:websiteId"
                            render={() => <LocationTabs isEditing={true} />}
                          />
                          <Route
                            exact
                            path="/d/:companyID/location/edit/:id/reviews"
                            render={() => <LocationTabs isEditing={true} />}
                          />
                          <Route
                            exact
                            path="/d/:companyID/location/edit/:id/subscriptions"
                            render={() => <LocationTabs isEditing={true} />}
                          />
                        </Switch>
                      </Route>

                      <Route exact path="/d/email" component={EmailListing} />
                      <Route
                        exact
                        path="/d/email/edit/:id"
                        component={EditEmail}
                      />
                      <Route exact path="/d/email/add" component={AddEmail} />
                      <Route
                        exact
                        path="/d/email/view/:id"
                        component={ViewEmail}
                      />

                      <Route
                        exact
                        path="/d/notification"
                        component={Notification}
                      />

                      <Route
                        exact
                        path="/d/notification/add"
                        component={AddNotification}
                      />
                      <Route
                        exact
                        path="/d/notification/edit/:id"
                        component={AddNotification}
                      />

                      <Route exact path="/d/home" component={Homes} />
                      <Route exact path="/d/home/add" component={HomesAdd} />
                      <Route
                        exact
                        path="/d/home/edit/:id"
                        component={HomesAdd}
                      />

                      <Route exact path="/d/enquiries" component={Enquiries} />
                      <Route
                        exact
                        path="/d/enquiries/care-hearth"
                        component={CareHearthAdmin}
                      />
                      <Route
                        exact
                        path="/d/enquiries/care-hearth/buyers"
                        component={CareHearthBuyers}
                      />
                      <Route
                        exact
                        path="/d/enquiries/care-hearth/buyers/:locationId"
                        component={CareHearthBuyerDetail}
                      />
                      <Route
                        exact
                        path="/d/enquiries/care-hearth/invoices"
                        component={CareHearthInvoices}
                      />
                      <Route
                        exact
                        path="/d/enquiries/care-hearth/disputes"
                        component={CareHearthDisputes}
                      />
                      <Route
                        exact
                        path="/d/enquiries/care-hearth/insights"
                        component={CareHearthInsights}
                      />
                      <Route
                        exact
                        path="/d/enquiries/care-hearth/insights/:locationId"
                        component={CareHearthInsightDetail}
                      />
                      <Route
                        exact
                        path="/d/enquiries/care-hearth/:uuid"
                        component={CareHearthDetail}
                      />
                      <Route
                        exact
                        path="/d/enquiries/add"
                        component={EnquiriesAdd}
                      />
                      <Route
                        exact
                        path="/d/enquiries/edit/:id"
                        component={EnquiriesAdd}
                      />

                      <Route exact path="/d/residence" component={Residence} />
                      <Route
                        exact
                        path="/d/residence/add"
                        component={ResidenceAdd}
                      />
                      <Route
                        exact
                        path="/d/residence/edit/:id"
                        component={ResidenceAdd}
                      />

                      <Route exact path="/d/news" component={News} />
                      <Route exact path="/d/news/add" component={NewsAdd} />
                      <Route
                        exact
                        path="/d/news/edit/:id"
                        component={NewsAdd}
                      />

                      <Route exact path="/d/blogs" component={Blogs} />
                      <Route exact path="/d/blogs/add" component={BlogsAdd} />
                      <Route
                        exact
                        path="/d/blogs/edit/:id"
                        component={BlogsAdd}
                      />

                      <Route exact path="/d/reviews" component={Reviews} />
                      <Route
                        exact
                        path="/d/reviews/add"
                        component={ReviewsAdd}
                      />
                      <Route
                        exact
                        path="/d/reviews/edit/:id"
                        component={ReviewsAdd}
                      />

                      <Route exact path="/d/care-types" component={TOC} />
                      <Route
                        exact
                        path="/d/care-types/add"
                        component={TOCAdd}
                      />
                      <Route
                        exact
                        path="/d/care-types/edit/:id"
                        component={TOCAdd}
                      />

                      <Route exact path="/d/packages" component={Package} />
                      <Route
                        exact
                        path="/d/package/add"
                        component={PackageAdd}
                      />
                      <Route
                        exact
                        path="/d/package/edit/:id"
                        component={PackageAdd}
                      />

                      <Route exact path="/d/bundles" component={Bundles} />
                      <Route exact path="/d/bundle/add" component={BundleAdd} />
                      <Route
                        exact
                        path="/d/bundle/edit/:id"
                        component={BundleAdd}
                      />

                      <Route
                        exact
                        path="/d/reviews/review-cards"
                        component={UploadCard}
                      />
                      <Route
                        exact
                        path="/d/reviews/review-cards/add"
                        component={UploadCardAdd}
                      />
                      <Route
                        exact
                        path="/d/reviews/review-cards/edit/:id"
                        component={UploadCardAdd}
                      />
                      <Route component={NotFoundPage} />
                    </Switch>
                  </Suspense>
                </DashBoard>
              </PrivateRoute>
            </Switch>
          </MuiPickersUtilsProvider>
        )}
      </Suspense>
    </>
  );
}
RootApp.propTypes = {
  isAuthenticating: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  checkAuth: PropTypes.func.isRequired,
};

const mapStateToProps = ({ AuthReducer }) => ({
  isAuthenticating: AuthReducer.isAuthenticating,
  isAuthenticated: AuthReducer.isAuthenticated,
  permissions: AuthReducer.permissions,
});
const mapDispatchToProps = (dispatch) => ({
  checkAuth: (...params) => dispatch(check(...params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RootApp);
